<template>
  <div class="fullscreen">
    <el-row class="fullrow" type="flex" justify="center" align="center">
      <el-col :offset="12" :span="112">
        <div class="abs">
          <div>
            <!-- <img class="logo" :src="require('@/assets/img/logo.png')" alt /> -->
            <!-- <img class="txt1" :src="require('@/assets/img/text3.png')" alt /> -->
            <div class="txt1">
              <!-- <div class="top">下载捷算APP 点击金融服务申请贷款</div> -->
              <div class="down">下载“捷算”APP</div>
              <div class="down">点击 <span style="color:#DC3C36">金融服务</span> 申请贷款！</div>
            </div>
            <div class="flex">
              <canvas id="qrccode-canvas" ></canvas>
              <div class="btn-box"> 
                <!-- <a @click="alertTip">
                  <img :src="require('@/assets/img/iosbtn.png')" alt />
                </a> -->
                <a :href="url" download>
                  <img :src="require('@/assets/img/androidbtn.png')" alt />
                </a>
                <img :src="require('@/assets/img/txt2.png')" alt />
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row class="m-fullrow" type="flex" justify="center" align="center">
      <el-col :span="24">
        <!-- <img class="m-txt1" :src="require('@/assets/img/mTxt1.png')" alt /> -->
         <div class="txt1" style="width:100%">
              <!-- <div class="top">下载捷算APP 点击金融服务申请贷款</div> -->
              <div class="down" style="font-size:32px">下载“捷算”APP</div>
              <div class="down" style="font-size:32px">点击 <span style="color:#DC3C36">金融服务</span> 申请贷款！</div>
            </div>
        <div class="m-flex">
          <!-- <a @click="alertTip">
            <img class="m-btn" :src="require('@/assets/img/mIos.png')" alt />
          </a> -->
          <a :href="url" download style="width:100%">
            <img style="width:60%;margin:0 auto" class="m-btn" :src="require('@/assets/img/mAndroid.png')" alt />
          </a>
        </div>
        <div class="canvas-box">
          <canvas id="m-qrccode-canvas"></canvas>
        </div>
        <img class="m-txt2" :src="require('@/assets/img/mTxt2.png')" alt />
      </el-col>
    </el-row>
  </div>
</template>
<script>
var QRCode = require('qrcode')
export default {
  data() {
    return {
      codeUrl: '',
      canvas: '',
      canvas2: '',
      url: ''
    }
  },
  beforeRouteEnter (to, from, next) {
    document.title = '捷算-app下载'
    next()
  },
  created() {
    this.appmanagement()
  },
  mounted() {
    this.canvas = document.getElementById('qrccode-canvas')
    this.canvas2 = document.getElementById('m-qrccode-canvas')
    this.codeUrl = window.location.href
    this.createQrc()
  },
  methods: {
    // 获取安卓下载地址
    appmanagement() {
      this.$request({
        url: '/api/android/appmanagement/id',
        method: 'post',
        data: {
          id: '281135150199406592'
        }
      }).then(res => {
        this.url = res.data.downloadPackage
      })
    },
    alertTip() {
      alert('即将上线，敬请期待!')
    },
    createQrc() {
      if (!this.codeUrl) {
        window.alert('链接不能为空')
        return false
      }
      QRCode.toCanvas(this.canvas, this.codeUrl, error => {
        if (error) {
          console.log(error)
        } else {
          console.log('success')
        }
      })
      QRCode.toCanvas(this.canvas2, this.codeUrl, error => {
        if (error) {
          console.log(error)
        } else {
          console.log('success')
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.fullscreen {
  width: 100%;
}
.fullrow {
  width: 100%;
  background: url('./../../assets/img/bg2.jpg') no-repeat center center;
  background-size: cover;
  height: 100vh;
}

img {
  display: block;
}
.flex {
  display: flex;
}
.logo {
  margin-bottom: 40px;
}
.txt1 {
  width: 603px;
  height: 181px;
  margin-bottom: 50px;
  font-family: AlibabaPuHuiTiR;
  .top{
    font-size: 24px;
    color: #676C71;
    margin-bottom: 24px;
  }
  .down{
      font-size: 45px;
      color: #1A1E22;
      line-height: 70px;
      font-weight: 700;
  }
}
.btn-box {
  padding-left: 40px;
  a {
    display: block;
    margin-bottom: 20px;
  }
}
.abs {
  display: flex;
  height: 100vh;
  align-items: center;
  justify-content: center;
}
#qrccode-canvas {
  border-radius: 5px;
  overflow: hidden;
  width: 250px!important;
  height: 250px!important;
//   position: absolute;
//   bottom: 111px;
//   left: 1083px;
//   width: 250px!important;
//   height: 250px!important;
}
.m-fullrow {
  display: none;
}
@media screen and (max-width: 750px) {
  .fullrow {
    display: none;
  }
  .m-fullrow {
    display: block;
    width: 100%;
    background: url('./../../assets/img/mBg.png') no-repeat center center;
    background-size: cover;
    height: 100vh;
  }
}
.m-txt1 {
  width: 85%;
  margin: 60px auto 80px;
  // background: orange;
}
.m-flex {
  display: flex;
  padding: 0 10px;
}
.m-flex a {
  flex: 1;
  padding: 0 10px;
}
.m-btn {
  width: 100%;
}
.canvas-box {
  text-align: center;
  padding: 20px 0 10px;
}
.m-txt2 {
  margin: 0 auto;
  width: 30%;
}
</style>